import { Component, Input, OnInit } from '@angular/core';
import { ColumnDefinition } from 'src/app/dashboardCommon/components/cardDetails/datatable.component';

@Component({
    selector: 'app-vacancies-table',
    templateUrl: './vacancies-table.component.html',
    styleUrls: ['./vacancies-table.component.css'],
    standalone: false
})
export class VacanciesTableComponent implements OnInit {

  @Input() columnDefinitions: ColumnDefinition[];

  @Input() tabledata: any[]

  constructor(
  ) { }

  ngOnInit(): void {

  }

  /**
   * Cierra la ventana
   */
  close() {
    window.close();
  }

}
